"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const clsx_1 = __importDefault(require("clsx"));
const MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const ClickAwayListener_1 = __importDefault(require("@material-ui/core/ClickAwayListener"));
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const menu_styles_1 = require("./menu-styles");
const sub_menu_1 = require("./sub-menu");
function MenuItem({ item, index, opened, onClick, onHover, onClickAway, classOverrides, }) {
    var _a, _b;
    const classes = menu_styles_1.useStyles();
    const handleClick = event_callback_hook_1.useEventCallback(() => {
        onClick(index);
    });
    const handleHover = event_callback_hook_1.useEventCallback(() => {
        onHover(index);
    });
    const handleClickAway = event_callback_hook_1.useEventCallback(() => {
        onClickAway(index);
    });
    const { pathname } = react_router_dom_1.useLocation();
    return (react_1.default.createElement(ClickAwayListener_1.default, { onClickAway: handleClickAway },
        react_1.default.createElement(MenuItem_1.default, { className: clsx_1.default(classes.menuItem, classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.menuItem, ((_a = item === null || item === void 0 ? void 0 : item.isActive) === null || _a === void 0 ? void 0 : _a.call(item, pathname)) && [
                classes.activeMenuItem,
                classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.activeMenuItem,
            ]), onMouseEnter: handleHover, onClick: handleClick },
            react_1.default.createElement(Typography_1.default, { variant: "inherit", className: clsx_1.default(classes.menuItemText, classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.menuItemText) }, item.label),
            opened && (react_1.default.createElement(sub_menu_1.SubMenu, { topLevel: true, items: (_b = item.items) !== null && _b !== void 0 ? _b : [], opened: opened, classOverrides: classOverrides })))));
}
exports.MenuItem = MenuItem;
//# sourceMappingURL=menu-item.js.map